import { AuthorizedService } from "@matchi/api";

export const getCheckoutQueryKey = (token: string) => ["checkout", token];

export const getCheckoutQuery = (token: string) => ({
  queryKey: getCheckoutQueryKey(token),
  queryFn: () => AuthorizedService.getCheckout(token),
});
